<router-outlet></router-outlet>
<crm-spinner></crm-spinner>
